import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";
import icn_btn_rediscover from "assets/images/icons/icn_btn_rediscover.svg";
import icn_board_alert from "assets/images/icons/icn_board_alert.svg";
import icn_ap from "assets/images/icons/icn_dashboard_ap.svg";
import icn_switch from "assets/images/icons/icn_dashboard_switch_off.svg";

import React, { useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Component
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

const AdoptView = ({
  viewStateEnum,
  getViewTitle,
  form,
  registerMacAddressItems,
  handleAdoptView,
}) => {
  const theme = useTheme();
  const viewRef = useRef(null);

  // Status

  // Method
  const closeView = () => {
    handleAdoptView.closeView();
  }

  // Side Effects

  const isFinish = registerMacAddressItems.every(item => item.result === "success" || item.result === "failure");
  const numberOfSuccess = registerMacAddressItems.filter(item => item.result === "success").length;
  const numberOfFailure = registerMacAddressItems.filter(item => item.result === "failure").length;

  return (
    <>
      <Box
        ref={viewRef}
        style={{
          position: "relative",
          padding: '0',
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              paddingLeft: "20px",
            }}
          >
            {getViewTitle(viewStateEnum.ADOPT)}
          </Typography>
          <Button
            onClick={closeView}
            disabled={!isFinish}
            sx={{
              backgroundColor: theme.palette.primary.transparent,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: theme.palette.primary.transparent,
              },
            }}
            style={{
              opacity: isFinish ? 1 : 0.5,
              cursor: isFinish ? 'pointer' : 'not-allowed',
            }}
          >
            <CloseIcon />
          </Button>
        </Box>
      </Box>

      <Box sx={{ textAlign: 'right', margin: '10px 20px 10px 0' }}>
        <Typography>
          Success: <span style={{ color: 'green' }}>{numberOfSuccess}</span>&nbsp;&nbsp;,
          Failed: <span style={{ color: 'red' }}>{numberOfFailure}</span>
        </Typography>
      </Box>

      <Box
        style={{
          border: `1px solid ${theme.palette.primary.borderGreyPrimary}`,
          borderRadius: '4px',
          margin: '0 10px 0 20px',
        }}
      >
        <Box sx={{ ...form.getTableStyle(), height: '300px', padding: '0 10px' }}>
          <TableContainer
            component={Paper}
            sx={{
              "&.MuiPaper-root": {
                boxShadow: "none",
                border: 'none',
              },
            }}
            style={{ overflowY: 'auto' }}
          >
            <Table
              sx={{
                borderCollapse: "collapse",
                "& td, & th": {
                  border: "none",
                },
                "& tbody tr:nth-of-type(odd)": {
                  backgroundColor: 'rgb(246, 246, 246)',
                },
                "& tbody tr:nth-of-type(even)": {
                  backgroundColor: theme.palette.primary.white,
                },
              }}
            >
              <TableHead>
                <TableRow style={{ borderBottom: `1px solid ${theme.palette.primary.borderGreyPrimary}` }}>
                  <TableCell sx={{ fontWeight: 600 }}>MAC Address</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>SN Information</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Model Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Result</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  registerMacAddressItems.map((mac, index) => (
                    <>
                      <TableRow key={index}>
                        <TableCell>
                          {mac.macAddress}
                        </TableCell>
                        <TableCell>
                          {mac.snInformation}
                        </TableCell>
                        <TableCell>
                          <Box display={'flex'} alignItems={'center'}>
                            {mac.isAp && (
                              <img
                                src={icn_ap}
                                alt=""
                                style={{ width: '16px', height: '16px', marginRight: '5px' }}
                              />
                            )}
                            {mac.isSwitch && (
                              <img
                                src={icn_switch}
                                alt=""
                                style={{ width: '16px', height: '16px', marginRight: '5px' }}
                              />
                            )}
                            <Box>
                              {mac.modelName}
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          {
                            mac.result === "success" && (
                              <Typography color="green" fontWeight={'bold'}>Success</Typography>
                            )
                          }
                          {
                            mac.result === "failure" && (
                              <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography color="red" fontWeight={'bold'}>Failed</Typography>
                                <Tooltip
                                  title="The SN and MAC pair is incorrect."
                                  placement="bottom"
                                  arrow
                                >
                                  <img
                                    src={icn_board_alert}
                                    alt="alert"
                                    style={{ width: '16px', height: '16px', marginLeft: '5px', verticalAlign: 'middle' }}
                                  />
                                </Tooltip>
                              </Box>
                            )
                          }
                          {
                            !mac.result && (
                              <img
                                src={icn_btn_rediscover}
                                alt="discovery"
                                style={{ width: '20px', height: '20px', marginRight: '5px' }}
                              />
                            )
                          }
                        </TableCell>
                      </TableRow>
                    </>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      <Box style={{ margin: '20px' }}>
        <Typography>
          Please ensure the devices' IP settings allow them to reach the controller before proceeding. Incorrect IP settings may prevent the devies from being adopted successfully.
        </Typography>
      </Box>


      <Box
        sx={{
          margin: "30px 0 16px auto",
          display: "flex",
          gap: "20px",
          justifyContent: "center",
        }}
      >
        {
          isFinish && (
            <SolidButton
              onClick={handleAdoptView.exportCsv}
              height="32px"
            >
              Export Result
            </SolidButton>
          )
        }
        <OutlineButton
          onClick={handleAdoptView.closeView}
          sx={{ marginRight: "20px" }}
          width="100px"
          height="32px"
          disabled={!isFinish}
        >
          Close
        </OutlineButton>
      </Box>
    </>
  )
}

export default React.memo(AdoptView);